import { TableBody, TableRow } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getAllShift } from './redux.selectors';
import TableCellContainer from '@libComponents/table/TableCellContainer';
import TableContainer from '@libComponents/table/TableContainer';
import TableHeaderContainer from '@libComponents/table/TableHeaderContainer';
import { ContentContainer } from '@libComponents/ContentContainer';
import { Button } from '@libComponents';
import dayjs from 'dayjs';
import { DeleteOutline } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/EditOutlined';
import { useEffect } from 'react';
import { fetchDatasets } from '@libs/datasets';
import { SHIFT } from 'common/redux.datasets';


export default function ViewShift({ setViewType, setData }) {
    const tableRows = useSelector((state) => getAllShift(state));
    const RXDispatch = useDispatch();
    useEffect(()=>{
        if(!tableRows){
            RXDispatch(fetchDatasets(SHIFT))
        }
    },[]);

    const TABLE_DATA = {
        'name': 'Name',
        'startTime': 'Start Time',
        'endTime': 'End Time'
    };

    const handleEdit = (row) => {
        setViewType('createShift');
        setData({ mode: 'update', row });
    }

    const handleDelete = (row) => {
        setViewType('deleteShift');
        setData({ row });
    }

    if (!tableRows) return null;
    return (
        <ContentContainer
            title='Shift'
            sx={{ border: 0, p: "0 !important", mb: 0 }}
            AdornmentComponent={
                <Button
                    onClick={() => {
                        setViewType('createShift');
                        setData({ mode: 'create', row:{} });
                    }}
                >
                    Add Shift
                </Button>
            }
        >

            <TableContainer sx={{ p: "0 !important" }}>
                <TableHeaderContainer>
                    {Object.values(TABLE_DATA).map((th, i) => (
                        <TableCellContainer typography='caption' key={th}>
                            {th}
                        </TableCellContainer>
                    ))}
                    <TableCellContainer typography='caption' key="action" align="right">
                        Actions
                    </TableCellContainer>
                </TableHeaderContainer>
                <TableBody>
                    {tableRows.map((row, i) => (
                        <TableRow key={i}>
                            {Object.keys(TABLE_DATA).map((key, index) => {
                                let columnData = row[key];
                                switch (key) {
                                    case 'startTime':
                                        return (
                                            <TableCellContainer key={key}>
                                                {dayjs(columnData).format("HH:mm")}
                                            </TableCellContainer>
                                        )
                                    case 'endTime':
                                        return (
                                            <TableCellContainer key={key}>
                                                {dayjs(columnData).format("HH:mm")}
                                            </TableCellContainer>
                                        )
                                    default:
                                        return (
                                            <TableCellContainer key={key}>
                                                {columnData}
                                            </TableCellContainer>
                                        )
                                }
                            })}
                            <TableCellContainer
                                align='right'
                                sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}
                            >
                                <EditIcon
                                    onClick={() => { handleEdit(row) }}
                                    sx={{ cursor: 'pointer', opacity: 0.75 }}
                                />

                                <DeleteOutline
                                    sx={{ cursor: 'pointer', opacity: 0.5 }}
                                    onClick={() => { handleDelete(row) }}
                                />
                            </TableCellContainer>
                        </TableRow>
                    ))}
                </TableBody>

            </TableContainer>
        </ContentContainer>
    );
}
